<template>
    <v-card class="mb-4">
        <v-card-title>
            Important Resources
        </v-card-title>
        <v-card-text>
            <v-list dense flat>
                <v-list-item-group :color="kingsGreen">
                    <v-list-item href="#/online-residence-application" link target="_self">
                        <v-list-item-icon>
                            <v-icon :color="kingsGreen">mdi-file-document-edit</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Apply for Residence</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item href="#/release-of-information" link target="_self">
                        <v-list-item-icon>
                            <v-icon :color="releaseOfInformationForm ? kingsGreen : dangerColor">mdi-file-document-edit
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Complete
                                your Release of Information Form</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon v-if="!releaseOfInformationForm">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :color="dangerColor" v-bind="attrs" v-on="on">mdi-alert-circle</v-icon>
                                </template>
                                <span>A Release of Information Form has not been completed.</span>
                            </v-tooltip>
                        </v-list-item-icon>
                    </v-list-item>
                    <v-list-item
                        href="https://mykings.ca/intranet/app/#/campus-life-and-services/parking-and-transportation"
                        link target="_blank">
                        <v-list-item-icon>
                            <v-icon :color="kingsGreen">mdi-parking</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Parking Services</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item href="https://www.kings.uwo.ca/campus-life/residence/" link
                        target="_blank">
                        <v-list-item-icon>
                            <v-icon :color="kingsGreen">mdi-home-city</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Residence Information</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'home-resources',
    props: {
        releaseOfInformationForm: {
            required: true,
            type: Boolean
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        kingsGold() {
            return '#d7ae28';
        },
        kingsGreen() {
            return '#004236';
        }
    }
}
</script>